// Derive the per-match metadata the server needs to credit element
// and avatar quests + populate the Hall of Fame on /me/match/claim.
// Pure client-side derivation; the server re-validates elements
// against an allow-list and only trusts the avatarId as an opaque
// tracking key.
//
// `deckElement` is non-null only when every coloured card in the deck
// shares a single element from the four-elements quest set (Air, Earth,
// Fire, Water). Multi-element decks resolve to null. The season pass
// rewards mono-element commitment, not splash decks.
//
// `deckElements` is the full set of tracked elements present in the
// deck (the multi-coloured Hall of Fame counter. A two-colour deck
// contributes one match toward each of its elements).
//
// `avatarId` is the unique_id of the first Avatar card in the deck.
// Used to grow the player's "avatars-won-with" set on a win for the
// `unique_avatars` quest and to power the Hall of Fame per-avatar
// rankings.
const TRACKED_ELEMENTS = ['Air', 'Earth', 'Fire', 'Water'];

export function getMatchQuestMeta(deck, sorceryCards) {
  if (!deck?.cards || !Array.isArray(sorceryCards)) {
    return { deckElement: null, deckElements: [], avatarId: null };
  }
  const cardIndex = new Map();
  for (const card of sorceryCards) {
    if (card?.unique_id) cardIndex.set(card.unique_id, card);
  }

  let avatarId = null;
  const elementsSet = new Set();
  for (const entry of deck.cards) {
    const card = cardIndex.get(entry.cardId);
    if (!card) continue;
    if (!avatarId && card.type === 'Avatar') {
      avatarId = card.unique_id;
    }
    if (Array.isArray(card.elements)) {
      for (const el of card.elements) {
        const name = el?.name;
        if (name && TRACKED_ELEMENTS.includes(name)) elementsSet.add(name);
      }
    }
  }

  const deckElements = TRACKED_ELEMENTS.filter((e) => elementsSet.has(e));
  const deckElement = deckElements.length === 1 ? deckElements[0] : null;
  return { deckElement, deckElements, avatarId };
}
